export class MachineOperationRequestData {
	public machineId: string;
	public constructor(machineid: string) {
		this.machineId = machineid;
	}
}
